import React, { useState } from 'react'
import { ButtonDropdown, DropdownMenu, DropdownToggle } from 'reactstrap'
import { dropDownIcon } from '../../../assets/images';
import './sort.scss'


type AppProps={
    data:any;
    handleChange:any;
    selectedData:{name:string,value:string}
}

const Index = ({data,handleChange,selectedData}:AppProps) => {
    const [isOpen,setIsOpen]=useState<boolean>(false);
    
    return (
        <ButtonDropdown
        isOpen={isOpen}
        toggle={() => {
           setIsOpen(!isOpen)
          }}
        >
    
          <DropdownToggle
            caret
            color="secondary"
            style={isOpen?{color:"#27273f",backgroundColor:"#fff",border:"1px solid #bfcbe1"} 
            : {color:"#27273f",backgroundColor:"#fff",border:"1px solid #bfcbe1"}}
            outline  
          >
            {selectedData?.name}
        
            <img src={dropDownIcon} alt="" />  
          </DropdownToggle>
    
          <DropdownMenu  right>
             <div className='pr-2 pl-2 sort-menu' style={{width:"250px"}}>
              {
                data?.map((item:any):any=>{
                    return (
                        <div className={`${selectedData?.name===item.name ? "dark": ""} pt-2 pb-2 pr-1 pl-1 pointer item-div`} 
                         onClick={()=>{
                            setIsOpen(!isOpen)
                            handleChange(item)
                        }}>{item?.name}</div>
                    )
                })
              }
            </div>
          </DropdownMenu>
        </ButtonDropdown>
      )
}

export default Index